<template>
  <router-link
    :to="{name: 'PoiView', params: {id: poi.id}}"
    tag="li"
    class="build-wrapper main-background"
    role="menuitem"
    :aria-label="$tr(poi.name)"
  >
    <h3 class="name">{{ $tr(poi.name) }}</h3>
    <div class="build" role="presentation">
      <div class="poi-image" :style="{backgroundImage: `url(${image})`}" role="presentation">
      </div>
      <div class="details" role="presentation">
        <p class="description" v-html="trimDetails($tr(poi.information))"></p>
        <div class="distance" v-if="showDistance" role="presentation">
          <i aria-hidden="true" class="material-icons">place</i>
          <span>{{ distance }} mi</span>
        </div>
      </div>
      <div class="select" v-if="editMode" role="presentation">
        <button
          class="selected"
          v-if="isSelected"
          @click.stop="deselect(poi)"
          aria-label="Remove POI from personal tour"
        ></button>
        <button
          class="unselected"
          v-else
          @click.stop="select(poi)"
          aria-label="Add POI to personal tour"
        ></button>
      </div>
    </div>
    <div class="slot-content" role="presentation">
      <slot></slot>
    </div>
  </router-link>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PoiBlock',
  props: {
    poi: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      default: false
    },
    showDistance: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      distance: '?'
    }
  },
  computed: {
    isSelected: function () {
      return this.checkPOISelected(this.poi)
    },
    image: function () {
      if (this.poi.mainImage) {
        return this.poi.mainImage.url
      } else if (this.poi.content.length > 0) {
        for (let i = 0; i < this.poi.content.length; i++) {
          const item = this.poi.content[i]

          if (item.type === 'image' && item.file) {
            return item.file.url
          }
        }
        return require('@/assets/build-example.png')
      } else {
        return require('@/assets/build-example.png')
      }
    },
    ...mapGetters({
      getDistance: 'getPOIDistance',
      position: 'getUserPosition'
    }),
    ...mapGetters('personalized', ['checkPOISelected'])
  },
  created () {
    this.updateDistance()
  },
  methods: {
    ...mapActions('personalized', {
      select: 'selectPoi',
      deselect: 'deselectPoi'
    }),
    updateDistance () {
      let distance = this.getDistance(this.poi)

      this.distance = distance !== undefined ? distance.toFixed(1) : '?'
    },
    trimDetails (details) {
      details = details ? details.replace(/<\/?[^>]+(>|$)/g, '') : null
      if (details) {
        let length = 80
        let trimmedString = details.length > length ? details.substring(0, length - 3) + '...' : details
        return trimmedString
      }
      return 'There is nothing to see here'
    }
  },
  watch: {
    position (newPos, oldPos) {
      this.updateDistance()
    }
  }
}
</script>
